import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useTheme } from '../../../utils/styles';
var UnCheckedIcon = /*#__PURE__*/React.memo(function (_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: theme.colors.neutral700,
    fillRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
    clipRule: "evenodd"
  }));
});
export default UnCheckedIcon;